import Mutations from '../../odata/mutations';

export default { ...new Mutations('Crn'), ...new Mutations('OInv'), ...new Mutations('client') };
